/**
 * Created by henian.xu on 2018/7/18.
 *
 */

import { Sv } from './Sv';

class Classroom extends Sv {
    constructor() {
        super();
        this.baseUrl += '/classroom';
    }

    data({ classroomName, remarks, certCatId, isAvailable, currentPage, pageSize } = {}) {
        return super.get('/data', {
            classroomName,
            remarks,
            certCatId,
            isAvailable,
            currentPage,
            pageSize,
        });
    }

    getDetail({ id }) {
        return super.get('/get', { id });
    }

    save({ id, remarks, classroomName, isAvailable, certCatIdList } = {}) {
        const certCatIds = certCatIdList
            .reduce((prev, curr) => {
                prev.push(curr);
                return prev;
            }, [])
            .join(',');
        return super.post('/save', {
            id,
            remarks,
            classroomName,
            isAvailable,
            certCatIds,
        });
    }

    delete({ ids } = {}) {
        return super.post('/delete', {
            ids,
        });
    }

    status({ id, isAvailable } = {}) {
        return super.post('/status', {
            id,
            isAvailable,
        });
    }

    selectByPage({ classroomName, certCatId, currentPage, pageSize } = {}) {
        return super.get('/selectByPage', {
            classroomName,
            certCatId,
            currentPage,
            pageSize,
        });
    }
}

export default new Classroom();
export { Classroom };
